<script>
export default {
    name: "PayComplete",
    created() {
        opener.completePayment(window, this.$route.query.ResultCode, this.$route.query.ResultMsg);
    }
};
</script>
